import { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from "react-icons/fa";
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import * as  Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { useSelector } from 'react-redux';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
export default function AffiliationBuildBlockReport() {
    const LandType = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const hasFetchedData = useRef(false)
    const AfflBuildingReportvalidation = Yup.object({
        data: Yup.array().of(Yup.object().shape({
            ffcaStatus: Yup.string().required(ERROR_MSG).nullable(),
            ffcaDeficiencies: Yup.string().required(ERROR_MSG).nullable(),

        })),
    })
    const AfflBldngBlockFormik = useFormik({
        initialValues: {
            data: [{
                ffcaStatus: "",
                ffcaDeficiencies: "",
                slNo: ""
            }]

        },
        validationSchema: AfflBuildingReportvalidation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}updateFfcaBuildingblocks`;
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetBuildingReport();

                        } else {
                            failureAlert("Failed to submit");
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })

    const [BuildingBlockData, setBuildingBlockData] = useState([])
    function GetBuildingReport() {
        let url = config?.url?.API_URL + "getbuildingblocks";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setBuildingBlockData(res?.data?.building);
                res?.data?.building?.forEach((buildingdata, i) => {
                    AfflBldngBlockFormik?.setFieldValue(`data[${i}].slNo`, buildingdata?.sl_no);
                    AfflBldngBlockFormik?.setFieldValue(`data[${i}].ffcaStatus`, buildingdata?.ffca_status?.toString() ?? "");
                    AfflBldngBlockFormik?.setFieldValue(`data[${i}].ffcaDeficiencies`, buildingdata?.ffca_deficiencies);

                })

            }
            else {
                setBuildingBlockData([]);

            }

        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetBuildingReport();
            GetCollegeType();
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>
            <CommonFormHeading heading="Building/Block Details Report" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={AfflBldngBlockFormik}>
                    <Form onChange={AfflBldngBlockFormik.handleChange} onSubmit={AfflBldngBlockFormik.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th className='cen'> Sl no</th>
                                            <th> Building/Block Name</th>
                                            <th>No. of Floors	</th>
                                            <th> Built Up Area ({LandType})	</th>
                                            <th> Building Image	</th>
                                            <th>  Is the Picture submitted by college and the Block really the same</th>
                                            <th>Please mention deficiencies /discrepancies identified ( if any)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {BuildingBlockData.map((empdata, index) => (<>
                                            <tr key={index}>

                                                <td className='cen'>{index + 1}</td>
                                                <td style={{ textAlign: "left" }}>{empdata?.build_block_name}</td>

                                                <td>{empdata?.no_of_floors}</td>
                                                <td>{empdata?.site_area || "-"}</td>
                                                <td>{empdata?.building_img ? (
                                                    <button type="button" className="btn btn-primary" onClick={() => { viewImage(empdata?.building_img) }}><FaEye size={20} className='cen' /></button>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                                </td>


                                                <td>
                                                    <Field type="hidden" name={`data[${index}].slNo`} />
                                                    <div>
                                                        <Field as="select" name={`data[${index}].ffcaStatus`} className="form-control"
                                                        // onChange={e => {
                                                        //     AfflBldngBlockFormik?.setFieldValue(`data[${index}].ffcaDeficiencies`, '');
                                                        // }}
                                                        >

                                                            <option value=''>--Select--</option>
                                                            <option value='true'>Yes</option>
                                                            <option value='false'>No</option></Field>
                                                        <ErrorMessage name={`data[${index}].ffcaStatus`} component="div" className="text-error" />


                                                    </div>
                                                </td>

                                                <td>
                                                    {/* {AfflBldngBlockFormik?.values?.data[index]?.ffcaStatus === 'true' && (<> */}

                                                    <Field as="textarea" name={`data[${index}].ffcaDeficiencies`} className="form-control" maxlength="350" />
                                                    <ErrorMessage name={`data[${index}].ffcaDeficiencies`} component="div" className="text-error" />


                                                    {/* </>)} */}
                                                </td>
                                            </tr>
                                        </>))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="button-cend pt-1 mb-3">
                                <button type='submit' className='btn btn-success btn-sm float-end rounded'>Submit</button>
                            </div><br />
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>



        </>)
}
